
import { Route } from 'vue-router';
import { Component, Vue } from 'vue-property-decorator';
import TopNavbar from '../components/navigation/TopNavbar.vue';
import GeneralMenu from '../components/navigation/GeneralMenu.vue';
import store from '../store/store';
import { performance } from '../shared/services/PerformanceService';
@Component({
    components: {
        TopNavbar,
        GeneralMenu,
    },
})
export default class Root extends Vue {

    created() {
        this.$store.state.appLoaded = true;
        if (window.hasOwnProperty('doorbellOptions')) {
            (window as any).doorbellOptions.email = this.$store.state.user.user.emailAddress;
            (window as any).doorbellOptions.name = this.$store.state.user.user.fullName;
            (window as any).doorbellOptions.hideEmail = true;
        }
    }

    mounted() {
        if (window.performance) {
            performance.measureAppLoad(window.performance.now());
        }
    }

    beforeRouteEnter(to: Route, from: Route, next: Function) {
        Root.handleIncoming(to, from, next);
    }

    beforeRouteUpdate(to: Route, from: Route, next: Function) {
        Root.handleIncoming(to, from, next);
    }

    private static handleIncoming(to: Route, from: Route, next: Function) {
        if (!to || to.name === 'root') {
            if (store.state.user.user.isParticipant) {
                next({ name: 'barometer', params: { personId: store.state.user.user.id.toString() } });
            } else if (store.state.user.user.isViewer) {
                next({ name: 'myDashboard' });
            } else {
                next({ name: 'notallowed' });
            }
        } else {
            next();
        }
    }
}
